import type { RouteObject } from 'react-router';

import { Suspense } from 'react';
import { Outlet } from 'react-router';

import lazyWithReload from 'src/utils/lazyWithReload';

import { CONFIG } from 'src/global-config';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

import { usePathname } from '../../../routes/hooks';

// ----------------------------------------------------------------------

const TaskListPage = lazyWithReload(() => import('src/pages/tasks/list'));
const TaskDetailsPage = lazyWithReload(() => import('src/pages/tasks/details'));

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
}

const TaskLayout = () => (
  <DashboardLayout>
    <SuspenseOutlet />
  </DashboardLayout>
);

export const taskRoutes: RouteObject[] = [
  {
    path: 'task',
    element: CONFIG.auth.skip ? TaskLayout() : <AuthGuard>{TaskLayout()}</AuthGuard>,
    children: [
      { index: true, element: <TaskListPage /> },
      { path: 'list', element: <TaskListPage /> },
      { path: ':id/details', element: <TaskDetailsPage /> },
    ],
  },
];
